<section id="eventLiveDetailWrap" class="event-live-detail-wrap">
  <div class="overlay blur" (click)="hideDetails()"></div>
  <div class="event-live-detail-container"> <!-- because of iPhone, sticky widget was blinking-->
    <section id="eventLiveDetail" class="event-live-detail"  [attr.data-sportId]="expandedEventResult.sportId">
      <div class="top-wrap">
        <div class="close-button" (click)="hideDetails()">X</div>
        <h2>{{expandedEventResult.regionName}} {{expandedEventResult.competitionName}}</h2>
      </div>
      <div class="bottom-wrap" id="bottomWrap">
          <div class="event-name">
              <span class="name">{{expandedEventResult.homeTeam}}</span>
              <span *ngIf="expandedEventResult.awayTeam && expandedEventResult.results[2] && expandedEventResult.results[2].scorePeriods[0]">{{expandedEventResult.results[2].scorePeriods[0].homeAwayValue[enumsHomeAway.HOME]}} : {{expandedEventResult.results[2].scorePeriods[0].homeAwayValue[enumsHomeAway.AWAY]}}</span>
              <span class="name">{{expandedEventResult.awayTeam}}</span>
          </div>
        <div class="line"></div>
        <div id="betMenuWrap" class="bet-menu-wrap">
          <ng-container *ngFor="let betTypeGroup of betTypeGroups">
            <span [class.selected]="betTypeGroup.isSelected" *ngIf="betTypeGroup.isOnline" (click)="selectGroup(betTypeGroup)">
                {{betTypeGroup.name | lowercase}}
              </span>
            </ng-container>
        </div>
      </div>
      <div class="bet-type-wrap">
        <ng-container *ngIf="selectedBetTypeGroup">
          <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroup.betTypeGroupingTemplateItems">
            <article class="single-bet-type-wrap" *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId]">
                <ng-container *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId]; let betAndBetTypeShowTypeForexpandedEventResult;">
                  <div class="bet-type-name" *ngIf="betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameHeaderRow
                  && betTypeGroupingTemplateItem.sbvSelectionType == SBVSelectionEnum.All">
                    <div class="flex">
                        <span *ngIf="expandedEventResult.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeName}}</span>
                        <span *ngIf="expandedEventResult.eventType == eventTypeENUM.Outright">{{betAndBetTypeShowTypeForexpandedEventResult.betTypeOutrightName}}</span>
                        <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeDescription" title="{{betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeDescription}}" (click)="showTitle($event)">
                          <i class="description-icon icon icon-ex-sm s-icon-sporticon-error"></i>
                          <!-- <span class="description-title"></span> -->
                        </span>
                    </div>
                  </div>
                  <div class="bets-conatainer bets-in-row-{{betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.numberOfBetsInRow}}">
                    <ng-container *ngFor="let bet of betAndBetTypeShowTypeForexpandedEventResult.bets; let i = index;" >
                      <div class="single-bet"  *ngIf="
                      (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.All ||
                      (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.MostBalanced && betAndBetTypeShowTypeForexpandedEventResult.mostBalancedBetIndex == i) ||
                      (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.Exact && bet.sbv === betTypeGroupingTemplateItem.sbvExactValue))
                      ">
                        <div class="bet-type-name" *ngIf="betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameSameRow || betTypeGroupingTemplateItem.sbvSelectionType != SBVSelectionEnum.All">
                          <div class="flex">
                              <span *ngIf="expandedEventResult.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeName}}</span>
                              <span *ngIf="expandedEventResult.eventType == eventTypeENUM.Outright">{{bet.outrightName}}</span>
                              <span class="sbv" *ngIf="betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.sbvDisplayType === SBVDisplayTypeEnum.SBVInBetType">
                                <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                                <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                              </span>
                              <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeDescription" title="{{betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeDescription}}" (click)="showTitle($event)">
                                <i class="description-icon icon icon-ex-sm s-icon-sporticon-error"></i>
                              </span>
                              <!-- <span class="icon cashout" *ngIf="betAndBetTypeShowTypeForexpandedEventResult.bets[0] && betAndBetTypeShowTypeForexpandedEventResult.bets[0].cashBackEnabled">
                                <span class="sporticon sporticon-transaction icon-ex-sm" title="Casheback"></span>
                              </span> -->
                          </div>
                        </div>
                        <div class="bet-outcomes-wrap" [ngClass]="{'one-column': betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeOutcomesList.length == 1, 'two-column': betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeOutcomesList.length == 2}" *ngIf="betAndBetTypeShowTypeForexpandedEventResult.isExpanded" >
                          <ng-container *ngFor="let bto of betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType.betTypeOutcomesList">
                              <ng-container *ngTemplateOutlet="outcome; context:{bet: bet, betTypeOutcome: bto, betTypeShowType: betAndBetTypeShowTypeForexpandedEventResult.betTypeShowType}">
                              </ng-container>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
            </article>
          </ng-container>
        </ng-container>
        <ng-template #outcome let-bet="bet" let-betTypeOutcome="betTypeOutcome" let-betTypeShowType="betTypeShowType">
            <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVAlone; else sbvInBetTypeOrOutcome;">
              <ng-container *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
                <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                  <div class="outcome-wrap">
                      <div class="outcome" [ngClass]="{'selected': betOutcome.resultStatus === outcomeResultStatusEnum.Passed}">
                          <span class="outcome-name">
                            <span class="name">{{betOutcome.name}}</span>
                          </span>
                          <span class="odd" >{{betOutcome.odd | odd}}</span>
                      </div>
                  </div>
                  <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1 && k == 0">
                      <div class="sbv disabled">
                        <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                        <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                      </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #emptyOutcome>
                <div class="outcome-wrap" *ngIf="bet.sbv">
                  <div class="outcome disabled">
                    <span class="outcome-name">
                      <ng-container *ngIf="betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOFullName">
                        {{betTypeOutcome.name}}
                      </ng-container>
                      <ng-container *ngIf="betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOShortName">
                        {{betTypeOutcome.shortName}}
                      </ng-container>
                    </span>
                    <span class="odd locked">
                      <app-svg-icon iconId="lock"></app-svg-icon>
                    </span>
                  </div>
                </div>
                <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1">
                  <div class="sbv disabled">
                    <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                    <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                  </div>
                </div>
              </ng-template>
            </ng-container>
            <ng-template #sbvInBetTypeOrOutcome>
              <ng-container  *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
                <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                  <div class="outcome-wrap">
                    <div class="outcome" [ngClass]="{'selected': betOutcome.resultStatus === outcomeResultStatusEnum.Passed}">
                        <span class="outcome-name">
                          <span class="name">{{betOutcome.name}}
                          <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                            <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                            <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                          </ng-container>
                          </span>
                        </span>
                        <span class="odd">{{betOutcome.odd | odd}}</span>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #emptyOutcome>
                <div class="outcome-wrap" *ngIf="bet.sbv">
                  <div class="outcome disabled">
                    <span class="outcome-name">
                      <span class="name">
                        <ng-container *ngIf="betTypeOutcome.mobileShowType == betTypeOutcomeShowTypeEnum.BTOFullName">
                          {{betTypeOutcome.name}}
                        </ng-container>
                        <ng-container *ngIf="betTypeOutcome.mobileShowType == betTypeOutcomeShowTypeEnum.BTOShortName">
                          {{betTypeOutcome.shortName}}
                        </ng-container>
                        <ng-container *ngIf="bet.sbv && betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                          <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                          <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                        </ng-container>
                      </span>
                    </span>
                    <span class="odd locked">
                      <app-svg-icon iconId="lock"></app-svg-icon>
                    </span>
                  </div>
                </div>
              </ng-template>
            </ng-template>
        </ng-template>
      </div>

    </section>
  </div>
</section>
